import { LOAD_STATE } from '@shared/axios/axios.constants';
import { createReducer, INITIAL_STATE } from '@shared/redux';
import { convertCampaignsToHash } from '@domain/campaigns';
import { AccountData, SubGroupState } from '@domain/advertising/advertising.types';
import { getAdSetsReportsConfig } from './ad-sets.api';

export const GET_AD_SETS_REQUEST_CALLED = '@advertising/ad-sets/GET_AD_SETS_REQUEST_CALLED';
export const GET_AD_SETS_REQUEST_SUCCEEDED = '@advertising/ad-sets/GET_AD_SETS_REQUEST_SUCCEEDED';
export const GET_AD_SETS_REQUEST_FAILED = '@advertising/ad-sets/GET_AD_SETS_REQUEST_FAILED';
export const GET_AD_SETS_REQUEST_CANCELED = '@advertising/ad-sets/GET_AD_SETS_REQUEST_CANCELED';

const initialState: SubGroupState = {
    loadState: LOAD_STATE.LOADING,
    data: {},
    error: null,
};

export const getAdSetsReportsStats = (
    accountsData: AccountData[],
) => ({
    type: GET_AD_SETS_REQUEST_CALLED,
    actionTypes: {
        success: GET_AD_SETS_REQUEST_SUCCEEDED,
        fail: GET_AD_SETS_REQUEST_FAILED,
        canceled: GET_AD_SETS_REQUEST_CANCELED,
    },
    config: getAdSetsReportsConfig(accountsData),
});

export const adSetsReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [GET_AD_SETS_REQUEST_CALLED]: state => ({
        ...state,
        error: null,
        loadState: LOAD_STATE.LOADING,
        data: {},
    }),
    [GET_AD_SETS_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        error: null,
        loadState: LOAD_STATE.SUCCESS,
        data: convertCampaignsToHash({ items: action.payload.data }, 'sublevel_id'),
    }),
    [GET_AD_SETS_REQUEST_FAILED]: (state, action) => ({
        ...state,
        error: action.payload,
        loadState: LOAD_STATE.FAIL,
        data: {},
    }),
    [GET_AD_SETS_REQUEST_CANCELED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.LOADING,
        data: {},
        error: action.payload,
    }),
});
